<script setup>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

import Sidenav from "@/views/layouts/Sidenav";
import Navbar from "@/views/layouts/Navbar.vue";
import AppFooter from "@/views/layouts/Footer.vue";

const store = useStore();
const showSidenav = computed(() => store.state.argonConfig.showSidenav);
const showNavbar = computed(() => store.state.argonConfig.showNavbar);
const showFooter = computed(() => store.state.argonConfig.showFooter);

onMounted(() => {
  const disableSpellcheck = () => {
    document.querySelectorAll('input, textarea, [contenteditable="true"]').forEach(el => {
      el.setAttribute('spellcheck', 'false');
      el.setAttribute('autocomplete', 'off');
    });
  };
  
  disableSpellcheck();
  const observer = new MutationObserver(disableSpellcheck);
  observer.observe(document.body, { childList: true, subtree: true });
});
</script>
<template>
  <sidenav v-if="showSidenav" />
  <main class="main-content position-relative max-height-vh-100 h-100">
    <navbar v-if="showNavbar" />
    <router-view />
    <Toast group="bl" position="bottom-left" />
    <app-footer v-show="showFooter" />
  </main>
</template>
